export default __webpack_public_path__ + "static/media/signal-ic.29e7c797.svg";